import React, { useState, useEffect } from "react";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import Loader from "../../components/styled-components/loader/loader";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";
import DEATH_API from "../../apis/death.api";
import "./deathDashboard.css";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const ContactListDashboard = (props) => {
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.role !== "trustee") {
      getContactList();
    }
  }, []);
  const getContactList = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchContactList(ID);
      setContactList([]);
      if (data && data.data && data.data[0] && data.data[0].contacts) {
        data.data[0].contacts.map(
          (item, idx) => (
            (item["phone"] =
              item.primaryCountryCode &&
              `${item.primaryCountryCode} ${item.phoneNumber}`),
            (item["idx"] = idx + 1)
          )
        );
        setContactList(data.data[0].contacts);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  function formatPhoneNumber(phoneWithCountryCode) {
    // Remove any non-numeric characters from the phone number
    const numericPhoneNumber = phoneWithCountryCode.replace(/\D/g, "");
    if (
      numericPhoneNumber.startsWith("1") &&
      numericPhoneNumber.length === 11
    ) {
      // Format as a USA number (e.g., +1 408-123-4567)
      return `+1 ${numericPhoneNumber.slice(1, 4)}-${numericPhoneNumber.slice(
        4,
        7
      )}-${numericPhoneNumber.slice(7)}`;
    } else if (
      numericPhoneNumber.startsWith("44") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a UK number (e.g., +44 20 1234 5678)
      return `+44 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        8
      )} ${numericPhoneNumber.slice(8)}`;
    } else if (
      numericPhoneNumber.startsWith("49") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Germany number (e.g., +49 30 12345678)
      return `+49 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        12
      )}`;
    } else if (
      numericPhoneNumber.startsWith("92") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Pakistan number (e.g., +92 300 1234567)
      return `+92 ${numericPhoneNumber.slice(2, 5)} ${numericPhoneNumber.slice(
        5,
        12
      )}`;
    } else {
      return phoneWithCountryCode;
    }
  }
  return (
    <div>
      {" "}
      <div
        className="cardHeading"
        style={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          CONTACT LIST
          <ToolTipCreator name={"Death_Contact_List"}/>
        </div>
        <div className="uploadButtons" style={{ width: "20px" }}>
          {" "}
          <div className="upload" style={{ width: "20px", height: "20px" }}>
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          height: "23rem",
        }}
      >
        {contactList && contactList.length > 0 ? (
          <div className="ContactTableConatier">
            <div style={{ height: "23rem" }}>
              <table className="ContactTable">
                <thead>
                  <tr className="ContactTable-Row">
                    <th className="ContactTable-data">Name</th>
                    <th className="ContactTable-data">Phone</th>
                    <th className="ContactTable-data">Email</th>
                    <th className="ContactTable-data">Trusted</th>
                    <th className="ContactTable-data">Type Of Relation</th>
                    <th className="ContactTable-data">
                      Access of Confidential
                    </th>
                  </tr>
                </thead>
                <tbody className="ContactTable-body">
                  {contactList &&
                    contactList.map((data, index) => (
                      <tr key={index} className="ContactTable-Row">
                        <td className="ContactTable-data">
                          {data.firstName && data.firstName}
                        </td>
                        <td className="ContactTable-data">
                          {data.phone ? formatPhoneNumber(data.phone) : "N/A"}{" "}
                        </td>
                        <td className="ContactTable-data">
                          {data.email ? data.email : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.isTrusted ? "Yes" : "No"}
                        </td>
                        <td className="ContactTable-data">
                          {data.typeOfRelation ? data.typeOfRelation : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.secondPasswordGranted ? "Yes" : "No"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection: "column",
            }}
          >
            {props.role !== "trustee" ? (
              "No Contact to Show"
            ) : (
              <React.Fragment>
                This information will be available to you soon!
                <img
                  src={protectedImg}
                  style={{ width: "50px", height: "50px", marginTop: "8px" }}
                  alt="protectedImg"
                ></img>
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
